import { useEffect } from "react";
import { useDealer, useSettings } from "@/contexts";
import { useDataApi } from "@/hooks";
import { formatAxiosError, isCode128, isDigit } from "@/utils";
import { ScannerInputValue } from "@/interfaces";
import { ScannerInput, ErrorMessage } from "../../atoms";
import * as S from "./styles";

export type DealerSearchProps = {
  autoFocus?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}; 

const testFn = (str: string): boolean => isCode128(str) || isDigit(str);

const DealerSearch: React.FC<DealerSearchProps> = ({
  autoFocus = undefined,
  onChange = undefined,
  onKeyPress = undefined,
}) => {
  const baseUrl = `${process.env.REACT_APP_REST_BASE_URL}/dealers`;
  const { setDealer } = useDealer();
  const { settings } = useSettings();
  const { data, isLoading, error, setUrl } = useDataApi();

  useEffect(() => {
    if (isLoading || error) {
      return;
    }

    if (data) {
      setDealer(data);
    }
  }, [data, isLoading, error, setDealer]);

  return (
    <S.DealerSearchContainer>
      <ScannerInput
        codeLength={settings?.dealerBadgeCodeLength}
        wait={0}
        fullWidth={true}
        placeholder="Scan badge or enter badge ID#"
        searchIcon={true}
        searchIconPosition="start"
        autoFocus={autoFocus}
        testFn={testFn}
        onChange={(value) => {
          if (onChange) {
            onChange({ target: { value: value?.value || '' } } as React.ChangeEvent<HTMLInputElement>);
          }
        }}
        onKeyPress={onKeyPress}
      />
      {error ? (
        <ErrorMessage
          errorMessage={
            error?.response?.status === 404
              ? "Dealer not found"
              : formatAxiosError(error)
          }
        />
      ) : null}
    </S.DealerSearchContainer>
  );
};

export default DealerSearch;
